export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/BE-240b25f38dd558b44350dccdd7f7e5c0.png";